import { Switch, Tmd14, Tmd18 } from 'oui';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

const Wrap = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 20px;
`;

const Left = styled.div`
  display: grid;
`;

interface IPrefRateContentItem {
  label: string;
  text: string;
  switchOn?: boolean;
  item: any;
}

interface IPrefRateContent {
  list: IPrefRateContentItem[];
  onClick: (item: IPrefRateContentItem, switchOn: boolean) => void;
}

export const PrefRateContent = ({ list, onClick }: IPrefRateContent) => {
  const [isToggle, setToggle] = useState<boolean[]>([]);

  const handleClickSwitch = (item: IPrefRateContentItem, idx: number) => {
    const current = isToggle[idx];
    if (onClick) {
      onClick(item, !current);
    }

    const after = isToggle.map((old, index) => index === idx ? !old : old);
    setToggle(after);
  };

  useEffect(() => {
    setToggle(list.map((item) => item.switchOn ?? false ));
  }, []);

  return (
    <>
      {list?.map((item, idx) => {
        return (
          <Wrap key={idx}>
            <Left>
              <Tmd14 text={item.label} color={'#696969'} />
              <Tmd18 text={item.text} />
            </Left>
            <Switch
              size={'md'}
              state={isToggle[idx] ? 'focused' : 'enabled'}
              color={'primary'}
              onClickButton={() => {} /*handleClickSwitch(item, idx) */} // 당분간 아무것도 하지 않음
            />
          </Wrap>
        );
      })}
    </>
  );
};
